import { Box, BoxProps } from '@front10/base-elements';
import React from 'react';
import { useWeekDaysLong, useWeekDayName } from '../i18n';

export type WeekDayProps = BoxProps & {
  weekday: number;
  weekDayFormat?: 'long' | 'short' | 'oneLetter' | null;
  style?: React.CSSProperties;
};

function WeekDay({ weekday, weekDayFormat = 'short', ...props }: WeekDayProps) {
  const weekDaysLong = useWeekDaysLong();
  const getWeekDayName = useWeekDayName();
  return (
    <Box
      as="th"
      p="1"
      className="front10-date-selector-weekday"
      {...props}
      aria-label={weekDaysLong[weekday]}
    >
      {getWeekDayName(weekday, weekDayFormat)}
    </Box>
  );
}

export default WeekDay;
